import React, { useState } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import { useModifier } from '../contexts/ModifiersContext';
import { CFormLabel } from '@coreui/react';

function ModifierSelectionForModifierGroup({ value, onChange, className, labelClassName, multiSelect = true, required = false, error = false }) {
    const requiredIcon = required ? <span className="text-danger">*</span> : null;

    const { getAllModifiers } = useModifier();

    const [totalRenderedRecords, setTotalRenderedRecords] = useState(0)
    const [filter, setFilter] = useState({
        limit: 50,
        totalRenderedRecords: totalRenderedRecords,
        filter: null
    });

    const fetchModifiers = async (searchValue, loadedOptions, { totalRenderedRecords }) => {
        try {
            const response = await getAllModifiers({ ...filter, filter: searchValue, totalRenderedRecords });

            if (response.totalPages > 0) {
                const newOptions = response.modifiers.length > 0 && response.modifiers.map((modifier) => ({
                    label: modifier.name,
                    value: modifier.id,
                }));

                const hasMore = totalRenderedRecords + newOptions.length < response.totalCount;

                return {
                    options: newOptions,
                    hasMore: hasMore,
                    additional: {
                        totalRenderedRecords: totalRenderedRecords + filter.limit,
                    },
                };
            } else {
                return {
                    options: [],
                    hasMore: false,
                    additional: null,
                };
            }
        } catch (error) {
            console.error('Error fetching modifiers', error);
            return {
                options: [],
                hasMore: false,
                additional: null,
            };
        }
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            whiteSpace: state.isFocused ? 'pre-wrap' : 'nowrap',
            wordBreak: state.isFocused ? 'break-all' : null,
            wordWrap: state.isFocused ? 'break-word' : null,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }),
    };

    return (
        <div className={className}>
            <div className={labelClassName}>
                <CFormLabel>Modifiers {requiredIcon}</CFormLabel>
            </div>
            <div className='w-100'>
                <AsyncPaginate
                    className={`${(error && required) && 'multiSelect_error'} `}
                    value={value}
                    loadOptions={fetchModifiers}
                    isMulti={multiSelect}
                    closeMenuOnSelect={!multiSelect ? true : false}
                    onChange={onChange}
                    placeholder='Select modifiers...'
                    noOptionsMessage={() => ('No modifiers found')}
                    loadingMessage={() => ('Modifiers Loading...')}
                    additional={{
                        totalRenderedRecords: totalRenderedRecords,
                    }}
                    SelectProps={{
                        isSearchable: true,
                    }}
                    menuShouldScrollIntoView={false}
                    menuPortalTarget={document.querySelector('body')}
                    styles={customStyles}
                />
                {(error && required) && <span className="text-danger error_message">Please select at least one modifier.</span>}
            </div>
        </div>
    );
}

export default ModifierSelectionForModifierGroup